/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
import pipe from 'lodash/fp/pipe.js';
import { connect } from 'react-redux';
import withNavigate from '#components/support/routing/withNavigate/index.jsx';
import withRouteParams from '#components/support/routing/withRouteParams/index.jsx';
import { fetchModel } from '#actions/models/model.js';
import { uploadDocumentAndStartExtraction } from '#actions/models/extractionJob.js';
import { endCreateModelFlow, leaveCreateModelFlowStep } from '#actions/models/createModelFlow.js';
import { modelById } from '#selectors/entities/models.js';
import UploadStep from './UploadStep.jsx';

const mapStateToProps = (state, ownProps) => ({
  model: modelById(state, { modelId: ownProps.routeParams.modelId }),
});

const mapDispatchToProps = {
  fetchModel,
  uploadDocumentAndStartExtraction,
  endCreateModelFlow,
  leaveCreateModelFlowStep,
};

export default pipe(
  connect(mapStateToProps, mapDispatchToProps),
  withNavigate,
  withRouteParams
)(UploadStep);
